import { Spacer, Text } from 'components';
import classes from 'classnames';
import classNames from 'classnames';
import React, { memo } from 'react';
import styles from './Table.module.scss';
import TableRow, { TableRowProps } from './TableRow';

type Props = {
  items: TableRowProps[];
  className?: string;
  classNameTitle?: string;
  title?: string;
  dataTest?: string;
};

export const Table = memo(function Table({
  className,
  classNameTitle,
  items,
  title,
  dataTest = 'table',
}: Props) {
  return (
    <>
      {title && (
        <Spacer className={classes(className, classNameTitle)}>
          <Text weight="bold" text={title} dataTest={`${dataTest}-title`} />
        </Spacer>
      )}
      <div
        className={classNames(
          styles['table-rows'],
          title && styles['with-title'],
          className,
        )}
        data-test="table-rows"
      >
        {items.map((item, index) => (
          <TableRow
            key={item.label}
            {...item}
            dataTest={`table-row-${index}`}
          />
        ))}
      </div>
    </>
  );
});
